import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { HashLink } from "../../../../navigation/HashLink";
import { useDealerAccountInfo } from "../../../../stores/hooks/useDealerAccountInfo";
import { PrimaryOutlinedButton } from "../../../../ui/Button/Button";
import { Section } from "../../../../ui/Section/Section";
import { AppointmentModal, appointmentHash } from "./XTimeAppointmentModal";
import { useXtimeAppointmentState } from "./useXtimeAppointmentState";

export const XTimeAppointment: FunctionComponent = () => {
  const shouldRenderAppointmentButton = useXtimeAppointmentState();
  const { dealerName } = useDealerAccountInfo();
  const { t } = useTranslation();

  if (!shouldRenderAppointmentButton) {
    return null;
  }

  return (
    <Section className="grid gap-2 sm:flex sm:justify-between sm:items-center">
      {t("cart.xTimeAppointmentHeadline", { dealerName })}
      <HashLink hash={appointmentHash}>
        <PrimaryOutlinedButton
          aria-label="showBookAppointmentDialog"
          className="flex sm:h-14"
          element="a"
        >
          {t("cart.bookAppointment")}
        </PrimaryOutlinedButton>
      </HashLink>
      <AppointmentModal />
    </Section>
  );
};
